var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('horizontal-bar-chart',{attrs:{"label":_vm.data.label,"chartdata":_vm.data.chartdata,"labels":_vm.data.labels,"height":"200"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }